<template>
  <b-container fluid>
    <ModalExportar :modeloId="model.ModeloDRE" />
    <el-tabs v-model="tabName" type="border-card">
      <el-tab-pane name="dre">
        <span slot="label"><i class="far fa-chart-bar"></i> DRE</span>
        <b-row>
          <div class="col-lg-12 col-md-12 mt-2">
            <container-card
              id="filtroDRE"
              icon="fa-filter"
              title="Selecione as opções de pesquisa."
            >
              <b-card>
                <!-- FILTROS -->
                <b-form id="formFiltro">
                  <b-form-row>
                    <div
                      :class="`${
                        model.analiseHorizontal
                          ? 'col-sm-12 col-md-12 col-lg-6 filtro-content'
                          : 'col-md-12'
                      }`"
                    >
                      <div class="filtro-content-box">
                        <h5 v-if="model.analiseHorizontal">Filtro A</h5>
                        <SelectMarcas v-model="model.marcas" />
                        <b-form-row class="mb-2">
                          <div class="col-lg-5 col-md-6">
                            <b-form-group
                              id="modelo_dre"
                              label="Modelo de DRE:"
                              class="position-relative"
                            >
                              <custom-select-single
                                v-model="model.ModeloDRE"
                                :opt="listas.modelosDRE"
                              />
                            </b-form-group>
                            <message-validation
                              :showError="
                                showValidation == true && model.ModeloDRE == ''
                              "
                            ></message-validation>
                          </div>
                          <div class="col-lg-7 col-md-6">
                            <template
                              v-if="
                                mostrarApenasCluster(
                                  'DRE',
                                  'VisaoDeConsultor'
                                ) && model.analiseHorizontal
                              "
                            >
                              <b-form-group>
                                <span slot="label">
                                  <div class="dre-empresa-cluster">
                                    <span>Empresas:</span>
                                    <b-form-checkbox
                                      v-model="
                                        model.configFiltro.mostrarApelido
                                      "
                                      v-show="
                                        !model.analiseHorizontal &&
                                        !model.filtroA.clusterEmpresaBool
                                      "
                                      style="font-weight: normal"
                                      >Apelido</b-form-checkbox
                                    >
                                  </div>
                                </span>

                                <custom-select-multiple
                                  v-if="isRerender"
                                  v-model="model.filtroA.Empresas"
                                  @options-loaded="updateEmpresasOptions"
                                  group
                                  :url="`${
                                    $urls.EMPRESAS
                                  }?marcas=${model.marcas.join(',')}&apelido=${
                                    model.configFiltro.mostrarApelido
                                  }&excluirInativos=${
                                    model.configFiltro.excluirInativas
                                  }`"
                                />
                              </b-form-group>
                            </template>
                            <template v-else>
                              <b-form-group
                                id="empresas"
                                label-for="empresasASelect"
                              >
                                <span slot="label">
                                  <div class="dre-empresa-cluster">
                                    <span>{{
                                      `Empresas${
                                        model.filtroA.clusterEmpresaBool
                                          ? " (Cluster)"
                                          : ""
                                      }:`
                                    }}</span>
                                    <b-form-checkbox
                                      v-model="
                                        model.configFiltro.mostrarApelido
                                      "
                                      v-show="
                                        !model.analiseHorizontal &&
                                        !model.filtroA.clusterEmpresaBool
                                      "
                                      style="font-weight: normal"
                                      >Apelido</b-form-checkbox
                                    >
                                  </div>
                                </span>
                                <div class="dre-toogle-multiselect-cluster">
                                  <small
                                    :class="
                                      model.analiseHorizontal
                                        ? 'label-toogle-cluster'
                                        : ''
                                    "
                                    >{{
                                      model.filtroA.clusterEmpresaBool
                                        ? "Alterar para empresas"
                                        : "Alterar para cluster"
                                    }}&nbsp;&nbsp;</small
                                  >
                                  <el-switch
                                    v-b-popover.hover.top="
                                      'Alternar combo clusters/empresas.'
                                    "
                                    v-model="model.filtroA.clusterEmpresaBool"
                                  ></el-switch>
                                </div>
                                <div
                                  v-show="
                                    model.filtroA.clusterEmpresaBool == false
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerender"
                                    v-model="model.filtroA.Empresas"
                                    group
                                    :url="`${
                                      $urls.EMPRESAS
                                    }?marcas=${model.marcas.join(
                                      ','
                                    )}&apelido=${
                                      model.configFiltro.mostrarApelido
                                    }&excluirInativos=${
                                      model.configFiltro.excluirInativas
                                    }`"
                                  />
                                </div>
                                <div
                                  v-show="
                                    model.filtroA.clusterEmpresaBool == true
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerender"
                                    v-model="model.filtroA.clusterEmpresa"
                                    :url="$urls.DRE_LISTA_CLUSTER"
                                  />
                                </div>
                              </b-form-group>
                            </template>
                          </div>
                        </b-form-row>
                        <b-form-row class="mb-2">
                          <div
                            :class="`${
                              model.analiseHorizontal
                                ? 'col-lg-6 col-md-6'
                                : 'col-lg-5 col-md-6'
                            }`"
                          >
                            <b-form-group
                              id="data_inicio_fim"
                              label="Data início/fim:"
                            >
                              <el-date-picker
                                v-model="model.filtroA.Month"
                                type="monthrange"
                                range-separator="|"
                                start-placeholder="Início"
                                end-placeholder="Fim"
                                format="MM/yyyy"
                                size="small"
                                class="w-100"
                              >
                              </el-date-picker>

                              <small
                                :style="`${
                                  mesesSelecionadosB > mesesSelecionadosA ||
                                  mesesSelecionadosA > 12
                                    ? 'color:#f00;'
                                    : ''
                                }`"
                                >{{
                                  mesesSelecionadosA > 0
                                    ? mesesSelecionadosA +
                                      (mesesSelecionadosA == 1
                                        ? " mês"
                                        : " meses") +
                                      " selecionados."
                                    : ""
                                }}</small
                              >
                            </b-form-group>
                            <message-validation
                              :showError="
                                showValidation == true &&
                                (isNullOrEmpty(model.filtroA.Inicio) ||
                                  isNullOrEmpty(model.filtroA.Fim))
                              "
                            ></message-validation>
                          </div>
                          <div
                            :class="`${
                              model.analiseHorizontal
                                ? 'col-lg-6 col-md-6'
                                : 'col-lg-7 col-md-6'
                            }`"
                          >
                            <template
                              v-if="
                                mostrarApenasCluster(
                                  'DRE',
                                  'VisaoDeConsultor'
                                ) && model.analiseHorizontal
                              "
                            >
                              <b-form-group label="Centro de Custo:">
                                <custom-select-multiple
                                  v-if="isRerender"
                                  v-model="model.filtroA.CentroDeCusto"
                                  @options-loaded="updateCentroCustoOptions"
                                  :url="`${
                                    $urls.CENTROS_DE_CUSTO
                                  }?marcas=${model.marcas.join(',')}&apelido=${
                                    model.configFiltro.mostrarApelido
                                  }&excluirInativos=${
                                    model.configFiltro.excluirInativas
                                  }`"
                                  group
                                />
                              </b-form-group>
                            </template>
                            <template v-else>
                              <b-form-group
                                id="centroDeCusto"
                                label-for="centroDeCustoSelect"
                              >
                                <span slot="label">
                                  <div class="dre-empresa-cluster">
                                    <span>{{
                                      `Centro de Custo${
                                        model.filtroA.clusterCentroDeCustoBool
                                          ? " (Cluster)"
                                          : ""
                                      }:`
                                    }}</span>
                                    <b-form-checkbox
                                      v-model="
                                        model.configFiltro.mostrarApelido
                                      "
                                      v-show="
                                        !model.analiseHorizontal &&
                                        !model.filtroA.clusterCentroDeCustoBool
                                      "
                                      style="font-weight: normal"
                                      >Apelido</b-form-checkbox
                                    >
                                  </div>
                                </span>
                                <div class="dre-toogle-multiselect-cluster">
                                  <small
                                    :class="
                                      model.analiseHorizontal
                                        ? 'label-toogle-cluster'
                                        : ''
                                    "
                                    >{{
                                      model.filtroA.clusterCentroDeCustoBool
                                        ? "Alterar para Centro de Custo"
                                        : "Alterar para cluster"
                                    }}&nbsp;&nbsp;</small
                                  >
                                  <el-switch
                                    v-b-popover.hover.top="
                                      'Alternar combo para clusters/Centro de custo.'
                                    "
                                    v-model="
                                      model.filtroA.clusterCentroDeCustoBool
                                    "
                                  ></el-switch>
                                </div>
                                <div
                                  v-show="
                                    model.filtroA.clusterCentroDeCustoBool ==
                                    false
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerender"
                                    v-model="model.filtroA.CentroDeCusto"
                                    @options-loaded="updateCentroCustoOptions"
                                    :url="`${
                                      $urls.CENTROS_DE_CUSTO
                                    }?marcas=${model.marcas.join(
                                      ','
                                    )}&apelido=${
                                      model.configFiltro.mostrarApelido
                                    }&excluirInativos=${
                                      model.configFiltro.excluirInativas
                                    }`"
                                    group
                                  />
                                </div>
                                <div
                                  v-show="
                                    model.filtroA.clusterCentroDeCustoBool ==
                                    true
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerender"
                                    v-model="model.filtroA.clusterCentroDeCusto"
                                    :url="`${
                                      $urls.CLUSTER_POR_CENTRO_CUSTO
                                    }?ccsIds=${model.filtroA.CentroDeCusto.join(
                                      ','
                                    )}&excluirInativos=${
                                      model.configFiltro.excluirInativas
                                    }`"
                                  />
                                </div>
                                <div
                                  class="check-outliers"
                                  v-show="
                                    model.filtroA.clusterEmpresaBool ||
                                    model.filtroA.clusterCentroDeCustoBool
                                  "
                                >
                                  <b-form-checkbox
                                    v-model="model.filtroA.excluirOutliers"
                                    >Desconsiderar Outliers</b-form-checkbox
                                  >
                                </div>
                              </b-form-group>
                            </template>
                          </div>
                        </b-form-row>
                        <b-form-row class="mb-2">
                          <div class="col-lg-3 col-md-3">
                            <b-form-group label="Status">
                              <b-form-radio-group
                                stacked
                                v-model="model.filtroA.Status"
                                :options="listas.statusOptions"
                                name="statusA"
                              >
                              </b-form-radio-group>
                            </b-form-group>
                          </div>
                          <div class="col-lg-9 col-md-9">
                            <b-card
                              bg-variant="light"
                              style="font-size: 0.8em"
                              :style="{
                                maxHeight: !(
                                  model.configFiltro.AnaliseVertical &&
                                  model.configFiltro.AnaliseHorizontal
                                )
                                  ? '100px'
                                  : ''
                              }"
                            >
                              <b-form-row>
                                <b-col lg="4" md="12">
                                  <b-form-group>
                                    <b-form-radio-group
                                      v-model="model.regime"
                                      :options="listas.regimeOptions"
                                      stacked
                                      name="regime"
                                    >
                                    </b-form-radio-group>
                                  </b-form-group>
                                </b-col>
                                <b-col lg="8" md="12">
                                  <b-form stacked id="checkboxes2">
                                    <b-row>
                                      <b-col style="max-width: 186px">
                                        <b-form-checkbox
                                          v-model="
                                            model.configFiltro.AnaliseVertical
                                          "
                                          :disabled="
                                            model.configFiltro.visaoPorLoja ||
                                            model.configFiltro
                                              .visaoPorCentroDeCusto
                                          "
                                          >Análise Vertical</b-form-checkbox
                                        >
                                        <b-form-checkbox
                                          v-model="
                                            model.configFiltro.AnaliseHorizontal
                                          "
                                          :disabled="
                                            model.configFiltro.visaoPorLoja ||
                                            model.configFiltro
                                              .visaoPorCentroDeCusto
                                          "
                                          >Análise Horizontal</b-form-checkbox
                                        >
                                      </b-col>
                                      <b-col>
                                        <b-form-checkbox
                                          v-model="
                                            model.configFiltro.TotalizarPeriodo
                                          "
                                          :disabled="
                                            model.configFiltro
                                              .MostrarCadaCentroDeCustoSeparadoPorColuna ||
                                            model.configFiltro.visaoPorLoja ||
                                            model.configFiltro
                                              .visaoPorCentroDeCusto
                                              ? true
                                              : false
                                          "
                                          >Totalizar Período</b-form-checkbox
                                        >
                                        <b-form-checkbox
                                          v-model="
                                            model.configFiltro.mostrarApelido
                                          "
                                          v-show="model.analiseHorizontal"
                                          >Apelido de empresas</b-form-checkbox
                                        >
                                        <b-form-checkbox
                                          v-model="
                                            model.configFiltro.excluirInativas
                                          "
                                          :disabled="
                                            model.configFiltro.visaoPorLoja ||
                                            model.configFiltro
                                              .visaoPorCentroDeCusto
                                          "
                                          >Excluir inativas</b-form-checkbox
                                        >
                                      </b-col>
                                    </b-row>
                                  </b-form>
                                </b-col>
                                <b-col>
                                  <b-form-checkbox
                                    v-if="
                                      model.configFiltro.AnaliseVertical &&
                                      model.configFiltro.AnaliseHorizontal
                                    "
                                    v-model="
                                      model.configFiltro.adicionarDiferenca
                                    "
                                    >Adicionar diferença % da analise
                                    vertical</b-form-checkbox
                                  >
                                </b-col>
                              </b-form-row>
                            </b-card>

                            <b-card bg-variant="light" style="font-size: 0.8em">
                              <b-form-row>
                                <b-col lg="8" md="12">
                                  <b-form stacked id="checkboxes2">
                                    <b-row>
                                      <b-col style="max-width: 380px">
                                        <div class="d-flex align-items-center">
                                          <b-form-checkbox
                                            v-model="
                                              model.configFiltro.visaoPorLoja
                                            "
                                            class="mr-3"
                                          >
                                            Visão por loja
                                          </b-form-checkbox>
                                          <b-form-checkbox
                                            v-model="
                                              model.configFiltro
                                                .visaoPorCentroDeCusto
                                            "
                                          >
                                            Visão por Centro de Custo
                                          </b-form-checkbox>
                                        </div>
                                        <b-form-checkbox
                                          v-model="
                                            model.configFiltro.tirarMedia
                                          "
                                          :disabled="
                                            !model.configFiltro.visaoPorLoja
                                          "
                                        >
                                          Tirar média
                                        </b-form-checkbox>
                                      </b-col>
                                    </b-row>
                                  </b-form>
                                </b-col>
                              </b-form-row>
                            </b-card>
                          </div>
                        </b-form-row>
                      </div>
                    </div>

                    <div
                      v-show="model.analiseHorizontal"
                      class="col-sm-12 col-md-12 col-lg-6 filtro-content"
                    >
                      <div class="filtro-content-box">
                        <h5>Filtro B</h5>
                        <SelectMarcas v-model="model.filtroB.marcas" />
                        <b-form-row class="mb-2">
                          <div class="col-lg-12 col-md-12">
                            <template
                              v-if="
                                mostrarApenasCluster('DRE', 'VisaoDeConsultor')
                              "
                            >
                              <b-form-group
                                :label="
                                  (model.filtroB.clusterEmpresaBool
                                    ? 'Cluster por '
                                    : '') + 'Empresas:'
                                "
                              >
                                <div class="dre-toogle-multiselect-cluster">
                                  <small
                                    :class="
                                      model.analiseHorizontal
                                        ? 'label-toogle-cluster'
                                        : ''
                                    "
                                    >{{
                                      model.filtroB.clusterEmpresaBool
                                        ? "Alterar para empresas"
                                        : "Alterar para cluster"
                                    }}&nbsp;&nbsp;</small
                                  >
                                  <el-switch
                                    v-b-popover.hover.top="
                                      'Alternar combo clusters/empresas.'
                                    "
                                    v-model="model.filtroB.clusterEmpresaBool"
                                  ></el-switch>
                                </div>
                                <div
                                  v-show="
                                    model.filtroB.clusterEmpresaBool == false
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerenderB"
                                    v-model="model.filtroB.Empresas"
                                    @options-loaded="updateEmpresasOptions"
                                    :url="`${$urls.EMPRESAS}?marcas=${
                                      model.filtroB.marcas
                                        ? model.filtroB.marcas.join(',')
                                        : ''
                                    }&apelido=${
                                      model.configFiltro.mostrarApelido
                                    }&excluirInativos=${
                                      model.configFiltro.excluirInativas
                                    }`"
                                    group
                                  />
                                </div>
                                <div
                                  v-show="
                                    model.filtroB.clusterEmpresaBool == true
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerenderB"
                                    v-model="model.filtroB.clusterEmpresa"
                                    :url="`${
                                      $urls.DRE_LISTA_CLUSTER
                                    }?empresasIds=${model.filtroB.Empresas.join(
                                      ','
                                    )}&excluirInativos=${
                                      model.configFiltro.excluirInativas
                                    }`"
                                  />
                                </div>
                              </b-form-group>
                            </template>
                            <template v-else>
                              <b-form-group
                                id="empresas"
                                :label="`Empresas${
                                  model.filtroB.clusterEmpresaBool
                                    ? ' (Cluster)'
                                    : ''
                                }:`"
                                label-for="empresasASelect"
                              >
                                <div class="dre-toogle-multiselect-cluster">
                                  <small
                                    :class="
                                      model.analiseHorizontal
                                        ? 'label-toogle-cluster'
                                        : ''
                                    "
                                    >{{
                                      model.filtroB.clusterEmpresaBool
                                        ? "Alterar para empresas"
                                        : "Alterar para cluster"
                                    }}&nbsp;&nbsp;</small
                                  >
                                  <el-switch
                                    v-b-popover.hover.top="
                                      'Alternar combo clusters/empresas.'
                                    "
                                    v-model="model.filtroB.clusterEmpresaBool"
                                  ></el-switch>
                                </div>
                                <div
                                  v-show="
                                    model.filtroB.clusterEmpresaBool == false
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerenderB"
                                    v-model="model.filtroB.Empresas"
                                    @options-loaded="updateEmpresasOptions"
                                    :url="`${$urls.EMPRESAS}?marcas=${
                                      model.filtroB.marcas
                                        ? model.filtroB.marcas.join(',')
                                        : ''
                                    }&apelido=${
                                      model.configFiltro.mostrarApelido
                                    }&excluirInativos=${
                                      model.configFiltro.excluirInativas
                                    }`"
                                    group
                                  />
                                </div>
                                <div
                                  v-show="
                                    model.filtroB.clusterEmpresaBool == true
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerenderB"
                                    v-model="model.filtroB.clusterEmpresa"
                                    :url="`${
                                      $urls.DRE_LISTA_CLUSTER
                                    }?empresasIds=${model.filtroB.Empresas.join(
                                      ','
                                    )}&excluirInativos=${
                                      model.configFiltro.excluirInativas
                                    }`"
                                  />
                                </div>
                              </b-form-group>
                            </template>
                          </div>
                        </b-form-row>
                        <b-form-row class="mb-2">
                          <div
                            :class="`${
                              model.analiseHorizontal
                                ? 'col-lg-6 col-md-6'
                                : 'col-lg-5 col-md-6'
                            }`"
                          >
                            <b-form-group
                              id="data_inicio_fim2"
                              label="Data início/fim:"
                            >
                              <el-date-picker
                                v-model="model.filtroB.Month"
                                type="monthrange"
                                range-separator="|"
                                start-placeholder="Início"
                                end-placeholder="Fim"
                                format="MM/yyyy"
                                size="small"
                                class="w-100"
                              >
                              </el-date-picker>
                              <small
                                :style="`${
                                  mesesSelecionadosB > mesesSelecionadosA ||
                                  mesesSelecionadosB < mesesSelecionadosA ||
                                  mesesSelecionadosA > 12
                                    ? 'color:#f00;'
                                    : ''
                                }`"
                                >{{
                                  mesesSelecionadosB > 0
                                    ? mesesSelecionadosB +
                                      (mesesSelecionadosB == 1
                                        ? " mês"
                                        : " meses") +
                                      " selecionados."
                                    : ""
                                }}</small
                              >
                            </b-form-group>
                            <message-validation
                              :showError="
                                showValidation == true &&
                                (isNullOrEmpty(model.filtroB.Inicio) ||
                                  isNullOrEmpty(model.filtroB.Fim))
                              "
                            ></message-validation>
                          </div>
                          <div
                            :class="`${
                              model.analiseHorizontal
                                ? 'col-lg-6 col-md-6'
                                : 'col-lg-7 col-md-6'
                            }`"
                          >
                            <template
                              v-if="
                                mostrarApenasCluster('DRE', 'VisaoDeConsultor')
                              "
                            >
                              <b-form-group
                                :label="
                                  (model.filtroB.clusterCentroDeCustoBool
                                    ? 'Cluster por '
                                    : '') + 'Centro de Custos:'
                                "
                              >
                                <div class="dre-toogle-multiselect-cluster">
                                  <small
                                    :class="
                                      model.analiseHorizontal
                                        ? 'label-toogle-cluster'
                                        : ''
                                    "
                                    >{{
                                      model.filtroB.clusterCentroDeCustoBool
                                        ? "Alterar para Centro de Custo"
                                        : "Alterar para cluster"
                                    }}&nbsp;&nbsp;</small
                                  >
                                  <el-switch
                                    v-b-popover.hover.top="
                                      'Alternar combo para clusters/Centro de custo.'
                                    "
                                    v-model="
                                      model.filtroB.clusterCentroDeCustoBool
                                    "
                                  ></el-switch>
                                </div>
                                <div
                                  v-show="
                                    model.filtroB.clusterCentroDeCustoBool ==
                                    false
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerenderB"
                                    v-model="model.filtroB.CentroDeCusto"
                                    @options-loaded="updateEmpresasOptions"
                                    :disabled="
                                      model.configFiltro
                                        .MostrarCadaCentroDeCustoSeparadoPorColuna
                                        ? true
                                        : false
                                    "
                                    :url="`${$urls.CENTROS_DE_CUSTO}?marcas=${model.filtroB.marcas}&apelido=${model.configFiltro.mostrarApelido}&excluirInativos=${model.configFiltro.excluirInativas}`"
                                    group
                                  />
                                </div>
                                <div
                                  v-show="
                                    model.filtroB.clusterCentroDeCustoBool ==
                                    true
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerenderB"
                                    v-model="model.filtroB.clusterCentroDeCusto"
                                    :url="`${
                                      $urls.CLUSTER_POR_CENTRO_CUSTO
                                    }?ccsIds=${model.filtroB.CentroDeCusto.join(
                                      ','
                                    )}&excluirInativos=${
                                      model.configFiltro.excluirInativas
                                    }`"
                                  />
                                </div>
                              </b-form-group>
                            </template>
                            <template v-else>
                              <b-form-group
                                id="centroDeCustoB"
                                :label="`Centro de Custo${
                                  model.filtroB.clusterCentroDeCustoBool
                                    ? ' (Cluster)'
                                    : ''
                                }:`"
                                label-for="centroDeCustoSelect"
                              >
                                <div class="dre-toogle-multiselect-cluster">
                                  <small
                                    :class="
                                      model.analiseHorizontal
                                        ? 'label-toogle-cluster'
                                        : ''
                                    "
                                    >{{
                                      model.filtroB.clusterCentroDeCustoBool
                                        ? "Alterar para Centro de Custo"
                                        : "Alterar para cluster"
                                    }}&nbsp;&nbsp;</small
                                  >
                                  <el-switch
                                    v-b-popover.hover.top="
                                      'Alternar combo para clusters/Centro de custo.'
                                    "
                                    v-model="
                                      model.filtroB.clusterCentroDeCustoBool
                                    "
                                  ></el-switch>
                                </div>

                                <div
                                  v-show="
                                    model.filtroB.clusterCentroDeCustoBool ==
                                    false
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerenderB"
                                    v-model="model.filtroB.CentroDeCusto"
                                    @options-loaded="updateEmpresasOptions"
                                    :disabled="
                                      model.configFiltro
                                        .MostrarCadaCentroDeCustoSeparadoPorColuna
                                        ? true
                                        : false
                                    "
                                    :url="`${$urls.CENTROS_DE_CUSTO}?marcas=${model.filtroB.marcas}&apelido=${model.configFiltro.mostrarApelido}&excluirInativos=${model.configFiltro.excluirInativas}`"
                                    group
                                  />
                                </div>
                                <div
                                  v-show="
                                    model.filtroB.clusterCentroDeCustoBool ==
                                    true
                                  "
                                >
                                  <custom-select-multiple
                                    v-if="isRerenderB"
                                    v-model="model.filtroB.clusterCentroDeCusto"
                                    :url="`${
                                      $urls.CLUSTER_POR_CENTRO_CUSTO
                                    }?ccsIds=${model.filtroB.CentroDeCusto.join(
                                      ','
                                    )}&excluirInativos=${
                                      model.configFiltro.excluirInativas
                                    }`"
                                    :disabled="
                                      model.configFiltro
                                        .MostrarCadaCentroDeCustoSeparadoPorColuna
                                        ? true
                                        : false
                                    "
                                  />
                                </div>
                                <div
                                  class="check-outliers"
                                  v-show="
                                    model.filtroB.clusterEmpresaBool ||
                                    model.filtroB.clusterCentroDeCustoBool
                                  "
                                >
                                  <b-form-checkbox
                                    v-model="model.filtroB.excluirOutliers"
                                    >Desconsiderar Outliers</b-form-checkbox
                                  >
                                </div>
                              </b-form-group>
                            </template>
                          </div>
                        </b-form-row>
                        <b-form-row class="mb-2">
                          <div class="col-lg-3 col-md-3">
                            <b-form-group label="Status">
                              <b-form-radio-group
                                stacked
                                v-model="model.filtroB.Status"
                                :options="listas.statusOptions"
                                name="statusB"
                              >
                              </b-form-radio-group>
                            </b-form-group>
                          </div>
                          <div class="col-lg-9 col-md-9"></div>
                        </b-form-row>
                      </div>
                    </div>
                  </b-form-row>
                </b-form>
                <info-box
                  type="warning"
                  title="Quantidade de colunas excedida"
                  text="Relatórios com mais de <b>36 colunas</b> são gerados exclusivamente via exportação para Excel."
                  v-if="QuantidadeDeColunas > 36"
                />
                <div slot="footer">
                  <div class="float-left btn-pesquisar">
                    <el-button
                      v-if="
                        QuantidadeDeColunas <= 36 && temAcesso('DRE', 'Obter')
                      "
                      size="small"
                      @click.prevent="pesquisarDRE"
                      type="primary"
                      icon="el-icon-search"
                      :disabled="pesquisarDisabled"
                      >Pesquisar</el-button
                    >
                    <el-button
                      v-else
                      size="small"
                      v-b-tooltip.hover
                      title="Sem permissões"
                      class="no-drop"
                      type="primary"
                      icon="el-icon-search"
                      >Pesquisar</el-button
                    >

                    <el-button
                      v-if="temAcesso('DRE', 'Obter')"
                      size="small"
                      @click.prevent="limparDRE"
                      icon="el-icon-brush"
                      >Limpar</el-button
                    >
                  </div>

                  <el-button
                    class="float-right"
                    v-if="temAcesso('DRE', 'Exportar')"
                    size="small"
                    type="success"
                    v-b-modal.modal-tipo-exportar
                    icon="el-icon-download"
                    >Exportar</el-button
                  >

                  <div class="float-right btn-exportar" v-else>
                    <button-validation
                      disabled
                      v-b-tooltip.hover
                      title="Sem permissões"
                      class="no-drop"
                    >
                      Exportar
                    </button-validation>
                  </div>
                </div>
              </b-card>
            </container-card>
            <div :class="showListDRE ? 'd-block' : 'd-none'">
              <container-card
                fixed
                id="valoresDRE"
                class="position-relative"
                icon="fa-th-list"
                title="Valores pesquisados."
              >
                <b-card>
                  <treeview-dre
                    :dataJson="treeViewData"
                    :mensagemErro="mensagemErro"
                  ></treeview-dre>
                </b-card>
              </container-card>
            </div>
          </div>
        </b-row>
      </el-tab-pane>

      <!-- VALORES MANUAIS -->
      <el-tab-pane v-if="temAcesso('DreValorManual', 'Obter')">
        <span slot="label"
          ><i class="fas fa-dollar-sign"></i> Valores Manuais</span
        >
        <valores-manuais
          :modeloId="model.ModeloDRE"
          :listaModelo="listas.modelosDRE"
        ></valores-manuais>
      </el-tab-pane>

      <!-- CMV -->
      <el-tab-pane name="cmv" v-if="isHavaianas">
        <span slot="label">CMV</span>
        <CMV></CMV>
      </el-tab-pane>
    </el-tabs>
  </b-container>
</template>
<script>
import ContainerCard from "@/components/shared/ContainerCard";
import TreeViewDRE from "@/components/TreeViewDRE";
import MessageValidation from "@/components/shared/MessageValidation";
import InfoBox from "@/components/shared/InfoBox";
import ValoresManuais from "@/views/DRE/ValoresManuais";
import CMV from "@/views/DRE/CMV";
import ModalExportar from "@/views/DRE/ModalExportar";
import ButtonValidation from "@/components/shared/ButtonValidation";
import isHavaianas from "@/mixins/isHavaianas";
import SelectMarcas from "@/components/shared/SelectMarcas";

const listas = () => {
  return {
    modelosDRE: [],
    empresas: [],
    centrosDeCusto: [],
    empresasB: [],
    centrosDeCustoB: [],
    cluster: [],
    clusterEmpresas: [],
    clusterCentroDeCusto: [],
    regimeOptions: [
      { text: "Regime de Competência", value: 1 },
      { text: "Regime de Caixa", value: 2 }
    ],
    statusOptions: [
      { text: "Ambos", value: 0 },
      { text: "Liquidados", value: 2 },
      { text: "Abertos", value: 1 }
    ]
  };
};
const model = () => {
  return {
    configFiltro: {
      AnaliseVertical: true,
      AnaliseHorizontal: false,
      TotalizarPeriodo: false,
      MostrarCadaCentroDeCustoSeparadoPorColuna: false,
      adicionarDiferenca: false,
      mostrarApelido: false,
      excluirInativas: false,
      visaoPorLoja: false,
      visaoPorCentroDeCusto: false,
      tirarMedia: false
    },
    analiseHorizontal: false,
    ModeloDRE: "",
    regime: 1,
    marcas: [],
    filtroA: {
      Empresas: [],
      Inicio: "",
      marcas: [],
      Fim: "",
      CentroDeCusto: [],
      Status: 0,
      Month: "",
      clusterEmpresaBool: false,
      clusterCentroDeCustoBool: false,
      clusterEmpresa: [],
      clusterCentroDeCusto: [],
      excluirOutliers: false
    },
    filtroB: {
      Empresas: [],
      marcas: [],
      inicio: "",
      fim: "",
      CentroDeCusto: [],
      Status: 0,
      Month: "",
      clusterEmpresaBool: false,
      clusterCentroDeCustoBool: false,
      clusterEmpresa: [],
      clusterCentroDeCusto: [],
      excluirOutliers: false
    }
  };
};

export default {
  name: "dre",
  components: {
    InfoBox,
    MessageValidation,
    ValoresManuais,
    CMV,
    ModalExportar,
    "button-validation": ButtonValidation,
    "container-card": ContainerCard,
    "treeview-dre": TreeViewDRE,
    SelectMarcas
  },
  mixins: [isHavaianas],
  data() {
    return {
      mesesSelecionadosA: 0,
      mesesSelecionadosB: 0,
      pesquisarDisabled: false,
      treeViewData: [],
      mensagemErro: {},
      showListDRE: false,
      exportarDisabled: false,
      exportarSistemaDisabled: false,
      exportarSistemaNotLoad: false,
      showValidation: false,
      isRerender: true, // render select
      isRerenderB: true, // render select
      isRerenderCentro: true,
      isRerenderCentroB: true,
      tabName: "dre",
      model: model(),
      listas: listas(),
      loadingsCluster: {
        lEmpresa: false,
        lCentroCusto: false
      },
      filtroOpcionalExportacao: {}
    };
  },
  methods: {
    exportarDRE() {
      const self = this;
      if (!self.isValidDRE()) return;

      this.exportarDisabled = true;
      this.trackingF360(this, "DRE", "Exportar formato dre");

      this.gerarRelatorio(self.$urls.DRE_EXPORTAR);
    },

    exportarParaSistemaAntigo() {
      const self = this;
      if (!self.isValidDRE()) return;

      this.exportarSistemaDisabled = true;
      this.trackingF360(this, "DRE", "Exportar formato tabela(único)");

      this.gerarRelatorio(self.$urls.DRE_EXPORTAR_SISTEMA);
    },

    exportarParaSistemaComTodasLinhas() {
      const self = this;
      if (!self.isValidDRE()) return;

      this.exportarSistemaDisabled = true;
      this.trackingF360(
        this,
        "DRE",
        "Exportar formato tabela(todas as linhas)"
      );

      this.gerarRelatorio(self.$urls.DRE_EXPORTAR_SISTEMA_TODAS_LINHAS);
    },

    exportarParaSistema() {
      const self = this;
      if (!self.isValidDRE()) return;

      this.exportarSistemaDisabled = true;
      this.trackingF360(this, "DRE", "Exportar formato tabela(diversos)");

      this.gerarRelatorio(this.$urls.DRE_EXPORTAR_EM_MASSA);
    },

    exportarDREPorCCs() {
      const self = this;
      if (!self.isValidDRE()) return;

      this.exportarDisabled = true;
      this.trackingF360(this, "DRE", "Exportar formato dre por ccs");

      this.gerarRelatorio(self.$urls.DRE_EXPORTAR_POR_CCS);
    },

    exportarDetalhesMultiplos(val) {
      const self = this;
      if (!self.isValidDRE()) return;

      this.filtroOpcionalExportacao = val;

      this.exportarDisabled = true;
      this.trackingF360(this, "DRE", "Exportar formato dre por ccs");

      this.gerarRelatorio(self.$urls.DRE_EXPORTAR_DETALHES_MULTIPLOS);
    },

    exportarParaSistemaComTodasLinhasEDetalhes() {
      const self = this;
      if (!self.isValidDRE()) return;

      this.exportarSistemaDisabled = true;
      this.trackingF360(
        this,
        "DRE",
        "Exportar formato tabela(todas as linhas com detalhes)"
      );

      this.gerarRelatorio(
        self.$urls.DRE_EXPORTAR_SISTEMA_TODAS_LINHAS_E_DETALHES
      );
    },

    gerarRelatorio(url) {
      this.requestGerarRelatorio(url);
      this.gerarRelatorioVisivel = false;
    },
    async requestGerarRelatorio(url) {
      let body = {
        ...this.paramsPesquisaDRE(),
        filtroOpcionalExportacao: this.filtroOpcionalExportacao
      };

      let request = await this.axios.post(url, body);

      if (request.status !== 200) {
        this.$message.error(
          "Algum erro interno aconteceu, por favor consulte nosso suporte."
        );
        return;
      }

      this.$notify({
        type: "success",
        title: "Gerando Relatório",
        dangerouslyUseHTMLString: true,
        message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
      });

      this.showValidation = false;
      this.exportarSistemaDisabled = false;
    },
    isValidDRE() {
      const self = this;

      if (
        self.model.ModeloDRE == "" ||
        self.isNullOrEmpty(self.model.filtroA.Inicio) ||
        self.isNullOrEmpty(self.model.filtroA.Fim)
      ) {
        self.showValidation = true;
        return false;
      }
      if (this.model.analiseHorizontal) {
        if (
          self.isNullOrEmpty(self.model.filtroB.Inicio) ||
          self.isNullOrEmpty(self.model.filtroB.Fim)
        ) {
          self.showValidation = true;
          return false;
        }

        if (
          this.mesesSelecionadosB > this.mesesSelecionadosA ||
          this.mesesSelecionadosB < this.mesesSelecionadosA
        ) {
          self.$message.error({
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: "<p>Os meses do filtroA e filtroB devem ser iguais.<p>",
            type: "error",
            duration: 6000
          });
          return false;
        }
      }

      if (this.mesesSelecionadosA > 12 || this.mesesSelecionadosB > 12) {
        self.$message.error({
          showClose: true,
          dangerouslyUseHTMLString: true,
          message:
            "<p>A quantidade de meses selecionados ultrapassou o <br><strong>limite de 12 meses.</strong><p>",
          type: "error",
          duration: 6000
        });
        return false;
      }

      return true;
    },

    paramsPesquisaDRE() {
      const self = this;

      var filterA = {
        nomeDoFiltro: "A",
        Status: self.model.filtroA.Status.toString(),
        dataInicio: self.model.filtroA.Inicio
          ? this.moment(self.model.filtroA.Inicio).format("YYYY-MM-DD")
          : "",
        dataFim: self.model.filtroA.Fim
          ? this.moment(self.model.filtroA.Fim).format("YYYY-MM-DD")
          : "",
        EmpresasIds: self.model.filtroA.Empresas.join(","),
        CentroDeCustosIds: self.model.filtroA.CentroDeCusto.join(","),
        clustersEmpresasIds: self.model.filtroA.clusterEmpresa.join(","),
        clustersCentroDeCustosIds:
          self.model.filtroA.clusterCentroDeCusto.join(","),
        marcas: self.model.marcas,
        excluirOutliers: self.model.filtroA.excluirOutliers
      };

      if (self.model.filtroA.clusterEmpresa.length) {
        filterA.EmpresasIds = "";
      }
      if (self.model.filtroA.clusterCentroDeCusto.length) {
        filterA.CentroDeCustosIds = "";
      }

      var filterB = {
        nomeDoFiltro: "B",
        Status: self.model.filtroB.Status.toString(),
        dataInicio: self.model.filtroB.Inicio
          ? this.moment(self.model.filtroB.Inicio).format("YYYY-MM-DD")
          : "",
        dataFim: self.model.filtroB.Fim
          ? this.moment(self.model.filtroB.Fim).format("YYYY-MM-DD")
          : "",
        EmpresasIds: self.model.filtroB.Empresas.join(","),
        CentroDeCustosIds: self.model.filtroB.CentroDeCusto.join(","),
        clustersEmpresasIds: self.model.filtroB.clusterEmpresa.join(","),
        clustersCentroDeCustosIds:
          self.model.filtroB.clusterCentroDeCusto.join(","),
        marcas: self.model.filtroB.marcas,
        excluirOutliers: self.model.filtroB.excluirOutliers
      };

      if (self.model.filtroB.clusterEmpresa.length) {
        filterB.EmpresasIds = "";
      }
      if (self.model.filtroB.clusterCentroDeCusto.length) {
        filterB.CentroDeCustosIds = "";
      }

      if (this.mostrarApenasCluster("DRE", "VisaoDeConsultor")) {
        filterB.clustersEmpresasIds =
          self.model.filtroB.clusterEmpresa.join(",");
        filterB.clustersCentroDeCustosIds =
          self.model.filtroB.clusterCentroDeCusto.join(",");
      }

      var filters = [];
      if (this.model.analiseHorizontal) {
        filters = [filterA, filterB];
      } else {
        filters = [filterA];
      }

      return {
        modeloDREId: self.model.ModeloDRE,
        tipoDeRegime: self.model.regime,
        AnaliseVertical: self.model.configFiltro.AnaliseVertical,
        AnaliseHorizontal: self.model.configFiltro.AnaliseHorizontal,
        TotalizarPeriodo: self.model.configFiltro.TotalizarPeriodo,
        adicionarDiferenca: self.model.configFiltro.adicionarDiferenca,
        MostrarCadaCentroDeCustoSeparadoPorColuna:
          self.model.configFiltro.MostrarCadaCentroDeCustoSeparadoPorColuna,
        visaoPorLoja: self.model.configFiltro.visaoPorLoja,
        visaoPorCentroDeCusto: self.model.configFiltro.visaoPorCentroDeCusto,
        tirarMedia: self.model.configFiltro.tirarMedia,
        EmpresaPorApelido: self.model.configFiltro.mostrarApelido,
        filters: filters,
        ExcluirEmpresasInativas: self.model.configFiltro.excluirInativas
      };
    },

    pesquisarDRE() {
      const self = this;

      if (!self.isValidDRE()) return;

      self.pesquisarDisabled = true;
      self.showListDRE = true;
      self.$root.$emit("loading", true);
      self.dreFiltros = self.paramsPesquisaDRE();

      this.trackingF360(this, "DRE", "Pesquisar");

      self.axios
        .post(this.$urls.DRE_LISTA, self.paramsPesquisaDRE())
        .then((res) => {
          self.treeViewData = res.data;
          self.$root.$emit("loading", false);

          if (res.data.length <= 0) {
            self.mensagemErro = { erro: false, msg: "Nada encontrado !" };
          }

          self.showValidation = false;
          self.pesquisarDisabled = false;
        })
        .catch(function () {
          self.treeViewData = [];
          self.$root.$emit("loading", false);

          self.pesquisarDisabled = false;
          self.showValidation = false;
          self.mensagemErro = {
            erro: true,
            msg: "Ocorreu algum problema com a requisição !"
          };
        });
    },

    limparDRE() {
      this.showValidation = false;
      this.$data.model = model();
      // this.callListas()

      this.model.filtroA.Inicio = "";
      this.model.filtroA.Fim = "";
      this.model.filtroA.Month = "";
    },
    callListas() {
      // call ModeloDRE
      var defaultModeloDre = (dt) => {
        if (!dt) {
          return false;
        }
        this.listas.modelosDRE = dt;

        // Define modelo default
        dt.forEach((item) => {
          if (item.default) {
            setTimeout(() => {
              this.model.ModeloDRE = item.id;
            }, 100);
            return false;
          }
          this.model.ModeloDRE = "";
        });
      };
      if (this.isNullOrEmpty(this.listas.modelosDRE)) {
        this.axios.get(this.$urls.DRE_MODELOS).then((dt) => {
          defaultModeloDre(dt.data);
        });
      } else {
        defaultModeloDre(this.listas.modelosDRE);
      }
    },
    validaExportarParaSistema() {
      if (
        this.model.configFiltro.AnaliseVertical == true ||
        this.model.configFiltro.AnaliseHorizontal == true ||
        this.model.configFiltro.MostrarCadaCentroDeCustoSeparadoPorColuna ==
          true
      ) {
        this.exportarSistemaDisabled = true;
        this.exportarSistemaNotLoad = true;
      } else {
        this.exportarSistemaDisabled = false;
        this.exportarSistemaNotLoad = false;
      }
    },
    async getClusterById(empresa) {
      const url = empresa
        ? this.$urls.CLUSTER_POR_EMPRESA
        : this.$urls.CLUSTER_POR_CENTRO_CUSTO;
      const name = empresa ? "lEmpresa" : "lCentroDeCusto";
      const ids = empresa
        ? this.model.filtroA.Empresas.join(",")
        : this.model.filtroA.CentroDeCusto.join(",");

      try {
        const params = {};

        params[empresa ? "empresasIds" : "ccsIds"] = ids;

        this.loadingsCluster[name] = true;

        const response = await this.axios.get(url, {
          params: params
        });

        if (response.status !== 200) {
          this.$notify.error({
            title: "Atenção",
            message: `Não foram encontrados clusters para ${
              empresa ? "Empresas" : "Centro de Custo"
            }`,
            position: "top-left"
          });
          return;
        }

        // ADD VALORES PARA NOVO SELECT
        if (empresa) {
          this.listas.clusterEmpresas = response.data;
        } else {
          this.listas.clusterCentroDeCusto = response.data;
        }
      } catch (err) {
        this.$notify.error({
          title: "Erro interno",
          message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
          position: "top-left"
        });
        console.error(err);
      } finally {
        this.loadingsCluster[name] = false;
      }
    },
    updateEmpresasOptions(options) {
      this.listas.Empresas = options;
    },
    updateCentroCustoOptions(options) {
      this.listas.centrosDeCusto = options;
    }
  },
  watch: {
    model: {
      handler: function () {
        this.showListDRE = false;
      },
      deep: true
    },
    "model.configFiltro.AnaliseVertical": function (val) {
      this.validaExportarParaSistema();
      if (!val) {
        this.model.configFiltro.adicionarDiferenca = false;
      }
    },
    "model.configFiltro.AnaliseHorizontal": function (val) {
      this.model.analiseHorizontal = val;
      if (val) {
        let filtroADefault = Object.assign({}, this.model.filtroA);
        this.model.filtroB = filtroADefault;

        this.model.filtroB.marcas = this.model.marcas;
      } else {
        this.model.configFiltro.adicionarDiferenca = false;
      }

      this.validaExportarParaSistema();
    },
    "model.configFiltro.MostrarCadaCentroDeCustoSeparadoPorColuna": function (
      val
    ) {
      if (val) {
        this.model.configFiltro.TotalizarPeriodo = val;
        this.model.filtroB.CentroDeCusto = this.model.filtroA.CentroDeCusto;
      }

      this.validaExportarParaSistema();
    },
    "model.filtroA.Empresas": function () {
      //this.getClusterById(true)
      this.model.filtroB.clusterEmpresa = [];
    },
    "model.filtroA.CentroDeCusto": function (val) {
      if (
        this.model.configFiltro.MostrarCadaCentroDeCustoSeparadoPorColuna ==
        true
      ) {
        this.model.filtroB.CentroDeCusto = val;
      }

      //this.getClusterById(false)
      this.model.filtroB.clusterCentroDeCusto = [];

      this.isRerenderCentro = false;
      this.$nextTick(() => {
        this.isRerenderCentro = true;
      });
    },
    "model.filtroA.Month": function (val) {
      if (!this.isNullOrEmpty(val)) {
        this.model.filtroA.Inicio = val[0];
        this.model.filtroA.Fim = val[1];
      } else {
        this.model.filtroA.Inicio = "";
        this.model.filtroA.Fim = "";
      }
    },
    "model.filtroB.Month": function (val) {
      if (!this.isNullOrEmpty(val)) {
        this.model.filtroB.Inicio = val[0];
        this.model.filtroB.Fim = val[1];
      } else {
        this.model.filtroB.Inicio = "";
        this.model.filtroB.Fim = "";
      }
    },
    "model.filtroA": {
      handler(val) {
        let inicio = this.moment(val.Inicio);
        let fim = this.moment(val.Fim);
        this.mesesSelecionadosA = val.Fim
          ? Number(fim.diff(inicio, "months")) + 1
          : 0;
      },
      deep: true
    },
    "model.filtroB": {
      handler(val) {
        let inicio = this.moment(val.Inicio);
        let fim = this.moment(val.Fim);
        this.mesesSelecionadosB = val.Fim
          ? Number(fim.diff(inicio, "months")) + 1
          : 0;
      },
      deep: true
    },
    "model.filtroA.clusterEmpresaBool": {
      handler() {
        this.model.filtroA.clusterEmpresa = [];
      }
    },
    "model.filtroA.clusterCentroDeCustoBool": {
      handler() {
        this.model.filtroA.clusterCentroDeCusto = [];
      }
    },
    "model.filtroB.clusterEmpresaBool": {
      handler() {
        this.model.filtroB.clusterEmpresa = [];
      }
    },
    "model.filtroB.clusterCentroDeCustoBool": {
      handler() {
        this.model.filtroB.clusterCentroDeCusto = [];
      }
    },
    "model.marcas"() {
      // sempre que marcas for alterado, redesenha o select de empresas
      this.isRerender = false;
      this.$nextTick(() => {
        this.listas.empresas = [];
        this.listas.centrosDeCusto = [];
        this.isRerender = true;
      });
    },
    "model.filtroB.marcas"() {
      // sempre que marcas for alterado, redesenha o select de empresas
      this.isRerenderB = false;
      this.$nextTick(() => {
        this.listas.empresasB = [];
        this.listas.centrosDeCustoB = [];
        this.isRerenderB = true;
      });
    },
    "model.configFiltro.mostrarApelido"() {
      // sempre que marcas for alterado, redesenha o select de empresas
      this.isRerender = false;
      this.$nextTick(() => {
        this.listas.empresas = [];
        this.listas.centrosDeCusto = [];
        this.isRerender = true;
      });
    },
    "model.configFiltro.excluirInativas"() {
      // sempre que excluirInativas for alterado, redesenha o select de empresas
      this.isRerender = false;
      this.$nextTick(() => {
        this.listas.empresas = [];
        this.listas.centrosDeCusto = [];
        this.isRerender = true;
      });
    },
    "model.configFiltro.visaoPorLoja"(visaoporloja) {
      if (visaoporloja) {
        this.model.configFiltro.AnaliseVertical = false;
        this.model.configFiltro.AnaliseHorizontal = false;
        this.model.configFiltro.TotalizarPeriodo = false;
        this.model.configFiltro.excluirInativas = false;
        this.model.configFiltro.visaoPorCentroDeCusto = false;
      }
    },
    "model.configFiltro.visaoPorCentroDeCusto"(visaoPorCentroDeCusto) {
      if (visaoPorCentroDeCusto) {
        this.model.configFiltro.AnaliseVertical = false;
        this.model.configFiltro.AnaliseHorizontal = false;
        this.model.configFiltro.TotalizarPeriodo = false;
        this.model.configFiltro.excluirInativas = false;
        this.model.configFiltro.visaoPorLoja = false;
      }
    }
  },
  computed: {
    QuantidadeDeColunas: function () {
      let mesesA = this.mesesSelecionadosA;
      let centroDeCustosSelecionados =
        this.model.filtroA.CentroDeCusto.join(",");
      let totalizar = this.model.configFiltro.TotalizarPeriodo;
      let mostrarCentroDeCustoColuna =
        this.model.configFiltro.MostrarCadaCentroDeCustoSeparadoPorColuna;
      let centroDeCustoList = this.listas.centrosDeCusto;
      let vertical = this.model.configFiltro.AnaliseVertical;
      let horizontal = this.model.configFiltro.AnaliseHorizontal;

      var obterValorBase = function () {
        if (vertical && horizontal) {
          return 5;
        } else if (horizontal) {
          return 3;
        } else if (vertical) {
          return 2;
        } else {
          return 1;
        }
      };

      let valorBase = obterValorBase();

      if (mostrarCentroDeCustoColuna) {
        var cc =
          centroDeCustosSelecionados.length > 0
            ? centroDeCustosSelecionados.length
            : centroDeCustoList.length;
        return valorBase * cc + 1 + (cc > 1 ? valorBase : 0);
      } else if (totalizar) {
        return valorBase + 1;
      } else {
        return valorBase * mesesA + 1 + (mesesA > 1 ? valorBase : 0);
      }
    },
    dreFiltros: {
      get() {
        return this.$store.state.dreFiltros;
      },
      set(value) {
        this.$store.commit("updateDREFiltros", value);
      }
    }
  },
  mounted() {
    this.callListas();
    //this.getClusterById(true);
    //this.getClusterById(false);
  }
};
</script>
<style lang="scss">
label.con-vs-radio,
div.con-vs-checkbox {
  -webkit-box-align: left;
  -ms-flex-align: left;
  align-items: left;
  -webkit-box-pack: left;
  -ms-flex-pack: left;
  justify-content: left;
}
.config .form-group {
  margin-bottom: 1rem;
  font-size: 0.8em;
}
.sticky-top {
  top: 58px !important;
}
.sticky-top:before,
.sticky-top:after {
  content: "";
  display: table;
}
.filtro-content {
  padding: 5px !important;
  .filtro-content-box {
    background: #e6edf5;
    border: 1px solid #b6c7da;
    min-height: 390px;
    border-radius: 3px;
    padding: 13px;
  }
}
.custom-control-inline {
  min-width: 165px;
}
.dre-toogle-multiselect-cluster {
  position: absolute;
  top: -2px;
  right: 6px;
}
.toogle-multiselect-cluster small {
  @media screen and (max-width: 440px) {
    position: absolute;
    top: -14px;
    right: -5px;
    width: 200px;
    text-align: right;
  }
}
.label-toogle-cluster {
  position: absolute;
  top: -14px;
  right: -5px;
  width: 200px;
  text-align: right;
}
.check-outliers {
  position: absolute;
  top: 55px;
  right: 5px;
  width: 200px;
  text-align: right;
  font-weight: normal;
  font-size: small;
}
.btn-pesquisar {
  @media screen and (max-width: 440px) {
    width: 100%;
    button {
      width: 48.2% !important;
      margin: 2px !important;
      display: inline-block;
    }
  }
  @media screen and (max-width: 340px) {
    button {
      width: 98% !important;
      margin: 2px !important;
      display: inline-block;
    }
  }
}
.btn-exportar {
  @media screen and (max-width: 440px) {
    width: 98% !important;
    margin: 2px;
    .btn-group {
      width: 100% !important;
    }
  }
}
.dre-empresa-cluster {
  display: flex;
  gap: 8px;
}
</style>
